// CSS
import "../css/index.css";
import "highlight.js/styles/base16/bespin.css";
import "highlightjs-copy/dist/highlightjs-copy.min.css";

// JS
import hljs from "highlight.js";
import CopyButtonPlugin from "highlightjs-copy";

hljs.addPlugin(new CopyButtonPlugin());
hljs.highlightAll();
